import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		button: {
			"&:active": {
				backgroundColor: theme.palette.action.disabledBackground,
				color: theme.palette.text.disabled,
			}
		},
	} satisfies Record<string, CSSObject>;
};
